import { Recipe } from "../types";

export const MarkdownRecipe: Recipe = {
  id: "markdown-recipe",
  name: "Markdown Recipe",
  globalKey: ["micro-topic"],
  prefix: "",
  format: {
    type: "markdown",
    fields: [],
    constraints: [],
  },
  validationRules: [],
};
